// @ts-nocheck

import { createContext } from 'react';

import { GRRounds, type GRRound as GRRoundType } from '../types/round';

export type GRRoundContextProps = {
  onChipClick?: (chipIndex: number) => void;
  lastSelectedChipIndex?: number | null;
  chipDetailsPanelIsOpened?: boolean;
  roundId: GRRoundType;
  isLocked?: boolean;
  isWon?: boolean;
};

export const GRRoundContext = createContext<GRRoundContextProps>({
  lastSelectedChipIndex: null,
  chipDetailsPanelIsOpened: false,
  roundId: GRRounds.SHOE,
});
